module.exports = __webpack_public_path__ + "static/img/sjOne.cfd4b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sjOne.jpg
// module id = 2tNv
// module chunks = 1